// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__1X0I6","input":"Controls_input__1zU3F","button":"Controls_button__31jsY","error":"Controls_error__3XmjB"};